import { PencilSquareIcon, } from '@heroicons/react/16/solid';
import { PiTrash } from "react-icons/pi";
import React, { useState, useEffect } from 'react';
import { getRequest, postRequest, updateRequest } from '../../utils/APICall';
import { Spin, message, Modal, Input } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import UpdatePayStructureForm from './UpdatePayslipStructure';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { BiArrowToBottom } from "react-icons/bi";
import { BiArrowFromBottom } from "react-icons/bi";
const PaySlipTable = ({ onDataReady }) => {
  const [payslipData, setPayslipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [delLoading, setDelLoading] = useState(false);
  const [individualPayslipData, setIndividualPayslipData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [expandedDate, setExpandedDate] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordModalVisible, setPasswordModalVisible] = useState(true);
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const T_Head = [
    "S.NO", "Employee Name", "Salary Head", "Basic Salary",
    "Issued From", "Year", "Action"
  ];
  const fetchPayslips = async () => {
    if (!isAuthenticated) return;
    setLoading(true);
    try {
      const res = await getRequest(`getStructurePayslip`);
      if (res.success) {
        setPayslipData(res?.data);
        onDataReady && onDataReady(res?.data)
        setLoading(false);
      } else {
        message.error(res.message || 'Failed to fetch payslips');
      }
    } catch (err) {
      console.error('Error fetching payslip data:', err);
      message.error('Error fetching payslip data');
    } finally {
      setLoading(false);
    }
  };
  const handlePasswordSubmit = async () => {
    if (!password.trim()) {
      message.error('Enter password');
      return;
    }
    try {
      const res = await postRequest("PayslipPassword", { password })

      if (res?.success) {
        setIsAuthenticated(true);
        setPasswordModalVisible(false);
        localStorage.setItem("payslipPasswordVerified", "true");
        fetchPayslips();
      } else {
        message.error('Incorrect password');
        // setPasswordModalVisible(false);
        // navigate('/');
      }
      setPassword("");
    } catch (error) {
      console.log(error)
    } finally {
      setPasswordModalVisible(false);
    }
  };

  useEffect(() => {
    const alreadyVerified = localStorage.getItem("payslipPasswordVerified");
    if (alreadyVerified) {
      setIsAuthenticated(true);
      setPasswordModalVisible(false);
    }
  }, []);
  useEffect(() => {
    if (isAuthenticated) {
      fetchPayslips();
    }
  }, [isAuthenticated]);

  const groupedByName = payslipData.length > 0
    ? Object.entries(
      payslipData.reduce((acc, item) => {
        const name = item.FIRSTNAME;
        const dateKey = moment(item.ISSUE_DATE).format("YYYY-MM-DD");
        if (!acc[name]) acc[name] = {};
        if (!acc[name][dateKey]) acc[name][dateKey] = [];
        acc[name][dateKey].push(item);
        return acc;
      }, {})
    )
    : [];

  const getIncrementAndDuration = (dates, dateKey, currentTotal) => {
    const allDates = Object.keys(dates).sort();
    const index = allDates.indexOf(dateKey);

    if (index <= 0) return { increment: "-", duration: "-" };

    const prevDate = allDates[index - 1];
    const prevItems = dates[prevDate];

    let prevEarn = 0;
    let prevDed = 0;

    prevItems.forEach((item) => {
      const amount = parseFloat(item.SALARYHEADS_AMOUNT) || 0;

      if (
        item.SALARY_HEAD_NAME?.toLowerCase().includes("deduction") ||
        item.SALARY_HEAD_NAME?.toLowerCase().includes("income tax") ||
        item.SALARY_HEAD_NAME?.toLowerCase().includes("loan")
      ) {
        prevDed += amount;
      } else {
        prevEarn += amount;
      }
    });

    const prevTotal = prevEarn - prevDed;

    const increment =
      prevTotal > 0 ? (((currentTotal - prevTotal) / prevTotal) * 100).toFixed(2) : "-";

    const duration = moment(dateKey).diff(moment(prevDate), "months") + " months";

    return { increment, duration };
  };

  const handleDeleteConfirm  = async () => {
    if (!individualPayslipData) return;
    setDelLoading(true)
    const payload = {
      empId : individualPayslipData?.EMP_ID ,
      salary_head_id : individualPayslipData?.SALARYHEADS_ID , 
      strucId : individualPayslipData?.SALARYSTRUCT_ID
    }
    try {
      const res = await updateRequest('deleteSalaryStruc', payload)
      if(res.success){
        message.success("Salary Structure Delete Successfully")
        fetchPayslips()
      }
    } catch (error) {
      console.log(error)
      setDeleteModal(false)
    } 
    finally{
      setDeleteModal(false)
      setIndividualPayslipData([])
      setDelLoading(false)
    }
  }

  return (
    <div className="font-[sans-serif] overflow-x-auto relative">
      {/* Password Modal */}
      <Modal
        title="Enter Password to View Payslips"
        open={passwordModalVisible}
        onOk={handlePasswordSubmit}
        onCancel={() => {
          setPasswordModalVisible(false);
          navigate('/');
        }}
        okText="Submit"
        cancelText="Cancel"
      >
        <Input.Password
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-2"
          onPressEnter={handlePasswordSubmit}
          iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        />
      </Modal>

      {loading ? (
        <div className="flex justify-center items-center p-10">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <table className="min-w-full bg-white">
            <thead className="bg-primaryPurple whitespace-nowrap">
              <tr>
                {T_Head.map((item, index) => (
                  <th
                    key={index}
                    className="p-4 text-left text-sm md:text-lg font-bold text-white"
                  >
                    {item}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="whitespace-nowrap">
              {groupedByName.map(([name, dates], nameIdx) => (
                <React.Fragment key={nameIdx}>
                  {/* Name Row */}
                  <tr className="bg-gray-200">
                    <td className="p-4 font-bold text-black" colSpan={T_Head.length}>
                      {name}
                    </td>
                  </tr>

                  {/* Date Rows */}
                  {Object.entries(dates).map(([dateKey, items]) => {
                    const fullKey = `${name}|${dateKey}`;
                    const isOpen = expandedDate === fullKey;
                    // console.log("Items ___>>>>>",items)
                    return (
                      <React.Fragment key={fullKey}>
                        {/* Clickable Issue Date Row */}
                        <tr
                          className="bg-gray-100 cursor-pointer "
                          onClick={() =>
                            setExpandedDate(prev =>
                              prev === fullKey ? "" : fullKey
                            )
                          }
                        >
                          <td className="p-4 text-black font-medium  w-full " colSpan={T_Head.length}>
                            {(() => {
                              let totalEarning = 0;
                              let totalDeduction = 0;

                              items.forEach((item) => {
                                const amount = parseFloat(item.SALARYHEADS_AMOUNT) || 0;
                                if (
                                  item.SALARY_HEAD_NAME?.toLowerCase().includes("deduction") ||
                                  item.SALARY_HEAD_NAME?.toLowerCase().includes("income tax") ||
                                  item.SALARY_HEAD_NAME?.toLowerCase().includes("loan")
                                ) {
                                  totalDeduction += amount;
                                } else {
                                  totalEarning += amount;
                                }
                              });
                              let totalIncome = totalEarning - totalDeduction
                              return (
                                <span className="ml-4 text-sm flex gap-5">
                                  {moment(dateKey).format("DD MMM YYYY")}

                                  <span className="text-green-500 font-bold">
                                    • Earnings: RS: {totalEarning?.toLocaleString("en-US")}
                                  </span>

                                  <span className="text-red-400 font-bold">
                                    • Deductions: RS:{totalDeduction?.toLocaleString("en-US")}
                                  </span>

                                  <span className="text-black font-bold">
                                    • Total: RS:{totalIncome?.toLocaleString("en-US")}
                                  </span>

                                  {/* NEW COLUMNS HERE */}
                                  {(() => {
                                    const inc = getIncrementAndDuration(dates, dateKey, totalIncome);
                                    return (
                                      <>
                                        <span className="text-blue-600 font-bold">
                                          • Increment: {inc.increment}%
                                        </span>

                                        <span className="text-purple-600 font-bold">
                                          • Duration: {inc.duration}
                                        </span>
                                      </>
                                    );
                                  })()}

                                  {isOpen ? (
                                    <BiArrowFromBottom className="h-6 w-6" />
                                  ) : (
                                    <BiArrowToBottom className="h-6 w-6" />
                                  )}
                                </span>

                              );
                            })()}
                          </td>
                        </tr>

                        {/* Collapsible Payslip Data */}
                        {isOpen &&
                          items.map((item, index) => (
                            <tr className="even:bg-blue-50" key={item.ID || index}>
                              <td className="p-4 text-sm text-black">{index + 1}</td>
                              <td className="p-4 text-sm text-black">{item.FIRSTNAME || '-'}</td>
                              <td className="p-4 text-sm text-black">{item.SALARY_HEAD_NAME || '-'}</td>
                              <td className="p-4 text-sm text-black">{item.SALARYHEADS_AMOUNT.toLocaleString('en-US') || '0'}</td>
                              <td className="p-4 text-sm text-black">
                                {moment(item.ISSUE_DATE).format('DD MMMM YYYY') || '-'}
                              </td>
                              <td className="p-4 text-sm text-black">{item.FINANCIAL_YEAR || '-'}</td>
                              <td className="p-4 flex items-center gap-2">
                                <div
                                  className="cursor-pointer bg-blue-100 p-1 rounded"
                                  onClick={() => {
                                    setModalVisible(true);
                                    setIndividualPayslipData(item);
                                  }}
                                >
                                  <PencilSquareIcon className="h-6 w-6 text-blue-500" />
                                </div>
                                <div
                                  className="cursor-pointer bg-red-100 p-1 rounded"
                                  onClick={() => {
                                    setDeleteModal(true);
                                    setIndividualPayslipData(item);
                                  }}
                                >
                                  <PiTrash className="h-6 w-6 text-red-500" />
                                </div>
                              </td>
                            </tr>
                          ))}
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          {deleteModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
              <div className="bg-white rounded-lg p-6 w-96 shadow-lg">
                <h2 className="text-lg font-semibold mb-4">
                  Confirm Delete
                </h2>

                <p className="text-sm text-gray-600 mb-6">
                  Are you sure you want to delete this Salary Structure?
                </p>

                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => {
                      setDeleteModal(false);
                      setIndividualPayslipData([]);
                    }}
                    className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleDeleteConfirm}
                    disabled={delLoading}
                    className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                  >
                    {delLoading ? "Deleting..." : "Delete"}
                  </button>
                </div>
              </div>
            </div>
          )}
          <UpdatePayStructureForm
            editingData={individualPayslipData}
            visible={modalVisible}
            onCancel={() => setModalVisible(false)}
            onOk={() => setModalVisible(false)}
          />
        </>
      )}
    </div>
  );
};

export default PaySlipTable;